<mat-form-field #formFieldContainer floatLabel="always" appearance="none" class="uploader-class">
   <mat-label
    #labelContainer  (click)="toggleTooltip(tooltip)"
    class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
    {{componentDefinition?.label}}
  </mat-label>
  <div class="labelToolTipContainer"
       #tooltip="matTooltip"
       matTooltip="{{componentDefinition.label}}"
       [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
  </div>
  <input matInput hidden />
  <canvas #imageCanvas style="display: none"></canvas>
  <fb-upload-file
    [disabled]="disabled"
    [fieldName]="fieldName"
    (onFileSelect)="onFileSelect($event)"
    [statusNote]="statusNote"
    [acceptedFiles]="extensionWhiteList"
  ></fb-upload-file>
  {{extensionWhiteList}}

  <!--- file uploader -->
  <div class="ft-uploader-main-wrap ft-uploader-v2-wrap ft-file-uploader">
    <div class="upload-process f-flex f-flex-column">
      <div *ngFor="let f of getNonImageFiles(); let i = index" [ngClass]="f.mode == 'TO_REMOVE' ? 'ft-uploader-v2-file-item to_remove' : 'ft-uploader-v2-file-item'">
        <a href="{{f.fileURL}}" download="{{f.fileName}}">
         <img class="file-icon" *ngIf="f.mode == 'VIEW' || f.mode == 'TO_REMOVE'"
             [src]="getNonImageFileIcon(f)"
             draggable="true" id="{{f.file96No|| f.fileNo}}____{{f.fileType}}"
             ondragstart="drag($event)" onerror="this.src='images/ft-uploader/ft-uploader-default-32.png'"
             title="Click to download '{{f.name || f.fileName}}'">
        </a>
         <span *ngIf="f.mode == 'VIEW'" class="ft-uploader-v2-file-item-span f-flex f-flex-align-items-center">
           <div class="fileBtnCpy" *ngIf="componentDefinition.linkTargetOutput">
             <button type="button" *ngIf="f.mode == 'VIEW'"
                     class="btn btn-xs copy-btn"
                     (click)='copyToClipboard(f, $event)'
                     title="Copy to clipboard">
               <mat-icon class="icon copy-icon active">content_copy</mat-icon>
               <mat-icon class="icon check-icon">done_all</mat-icon>
             </button>
           </div>
          <button type="button" class="btn btn-xs btn-warning material-icons" (click)="confirmDelete(f)"
                  *ngIf="f.mode == 'VIEW'" title="Confirm Delete file">delete_forever
          </button>
        </span>

        <span *ngIf="f.mode == 'TO_REMOVE'" class="ft-uploader-v2-file-item-span">
          <button type="button" class="btn btn-xs btn-success material-icons" (click)="removeFile(f)" title="Confirm Delete file">check
          </button>
          <button type="button" class="btn btn-xs btn-warning material-icons" (click)="confirmDelete(f)" title="Cancel Delete file">close
          </button>
        </span>

        <a *ngIf="f.fileURL !== undefined" href="{{f.fileURL}}" target="_blank" class="link">{{f.fileName}}</a>
        <a (click)="download(f);" *ngIf="f.fileURL === undefined" class="link">{{f.name || f.fileName}}</a>




        <span *ngIf="f.mode != 'VIEW' && f.mode != 'TO_REMOVE'">
          <div class="progress" style="width: 75px;">
            <div [style.width.%]="f.progress" class="progress-bar" role="progressbar">
              {{f.progress}}%
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>

  <!-- end  file uploader -->

  <!-- image uploader-->
  <div class="ft-uploader-main-wrap ft-uploader-v2-wrap ">
    <div id="links" class="f-flex f-flex-wrap">
      <span *ngFor="let f of getImageFiles(); let i = index" class="thumbnail-list-block">
        <span>
          <div class="imagewrap container-uploader">
            <div>
              <a #imgHrefElem class="hide-temporary-href" download="{{f.fileName}}" href="{{ (f.resources ? (f.resources.base64strData || f.resources.url) : null) }}"
                 title="{{f.fileName}}"></a>
              <a (click)="$event.preventDefault();" data-gallery
               download="{{f.fileName}}" href="{{ (f.resources ? (f.resources.base64strData || f.resources.url) : null) }}"
               title="{{f.fileName}}">
                <img [src]="(f.resources ? (f.resources.base64strData || f.resources.url) : null)"
                   class="media-object img-thumbnail img-responsive"
                   (click)="viewImage(f)"
                   ondragstart="drag($event)"
                   onerror="this.src='images/ft-uploader/ft-uploader-default-gallery-placeholder.png';"
                   style="height: 75px; width: 75px; object-fit: cover; overflow: hidden;"/>
               </a>

            </div>
            <!-- <button (click)="removeFile(f)" *ngIf="allowDeletion && f.mode == 'VIEW'"
                    class="btn btn-raised btn-warning material-icons buttonDelete"
                    title="Remove this file" type="button">delete_forever
            </button> -->

            <button type="button" *ngIf="f.mode == 'VIEW'"
                    class="btn btn-raised btn-success material-icons buttonDownload"
                    (click)="imgHrefElem.click()"
                    title="Download this file">download</button>
            <button type="button" *ngIf="allowDeletion && f.mode == 'VIEW' "
                    class="btn btn-raised btn-warning material-icons buttonDelete"
                    (click)="confirmDelete(f)"
                    title="Remove this file">delete_forever</button>
            <div class="buttonCpy" *ngIf="componentDefinition.linkTargetOutput">
              <button type="button" *ngIf="f.mode == 'VIEW'"
                      class="btn copy-btn"
                      (click)='copyToClipboard(f, $event)'
                      title="Copy to clipboard">
                <mat-icon class="icon copy-icon active">content_copy</mat-icon>
                <mat-icon class="icon check-icon">done_all</mat-icon>
              </button>
            </div>

            <div  *ngIf="f.mode == 'TO_REMOVE'">
              <button type="button"
                      class="btn btn-raised btn-success material-icons buttonDeleteConfirm"
                      (click)="removeFile(f)"
                      title="Remove this file">check</button>
              <button type="button"
                      class="btn btn-raised btn-warning material-icons buttonDelete"
                      (click)="confirmDelete(f)"
                      title="Cancel Remove this file">close</button>
            </div>
            <!-- <div *ngIf="f.fileURL !== undefined" >
              <figcaption title="{{f.fileName}}"> <a href="{{f.fileURL}}" target="_blank">{{f.fileName}} </a></figcaption>
            </div> -->
          </div>
        </span>
        <span *ngIf="f.mode != 'VIEW' && f.mode != 'TO_REMOVE'">
          <div class="progress" style="width: 75px;">
            <div [style.width.%]="f.progress" class="progress-bar" role="progressbar">
              {{f.progress}}%
            </div>
          </div>
        </span>
      </span>
    </div>
  </div>
  <!-- end  image uploader-->
</mat-form-field>
